import store from "@/store"

const devUserConfig = {
  user_data: {
    id: process.env.VUE_APP_CARTO_DEV_USER_ID,
    username: 'dev',
    api_key: process.env.VUE_APP_CARTO_DEV_USER_API_KEY,
    base_url: process.env.VUE_APP_CARTODB_SERVER + "/user/dev"
  },
  config: {
    maps_api_template: process.env.VUE_APP_CARTODB_SERVER + "/user/{user}"
  }
}

export default function getCARTOData() {
  return (store && store.state.auth.cartoConfig) || devUserConfig
}